import { call } from "redux-saga/effects";

let getAllItemModule = null;
export function* getAllItem(args) {
  if (!getAllItemModule) {
    getAllItemModule = yield call(() => import('./get-all-item'));
  }
  //llamada a modulo
  yield call(getAllItemModule.initGetDevicesListItems, args)
}